
import ArticleForm from "@/components/sections/admin/ArticleForm";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

interface Article {
  id: string;
  title: string;
  description: string;
  image_url: string;
  content: string;
  status?: string;
}

const AdminArticles = () => {
  console.log("[AdminArticles] Rendering AdminArticles component");
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [editingArticle, setEditingArticle] = useState<Article | null>(null);
  const editId = searchParams.get("edit");

  // Fetch article if edit ID is present
  useQuery({
    queryKey: ["article", editId],
    queryFn: async () => {
      if (!editId) return null;
      
      const { data, error } = await supabase
        .from("articles")
        .select("*")
        .eq("id", editId)
        .single();

      if (error) throw error;
      setEditingArticle(data);
      return data;
    },
    enabled: !!editId,
  });

  const handleSuccess = () => {
    // Invalidate both query keys to ensure fresh data
    queryClient.invalidateQueries({ queryKey: ["articles"] });
    queryClient.invalidateQueries({ queryKey: ["all-articles"] });
    setEditingArticle(null);
    
    // Navigate to articles list after successful creation
    if (!editId) {
      navigate("/admin/articles/list");
    }
  };

  return (
    <div className="min-h-screen py-24">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold mb-8">
          {editingArticle ? "Edit Article" : "Create New Article"}
        </h1>
        <ArticleForm 
          onSuccess={handleSuccess} 
          editingArticle={editingArticle} 
        />
      </div>
    </div>
  );
};

export default AdminArticles;
